import { render, staticRenderFns } from "./PpvNegativesSection.vue?vue&type=template&id=458906d0&scoped=true"
import script from "./PpvNegativesSection.vue?vue&type=script&lang=js"
export * from "./PpvNegativesSection.vue?vue&type=script&lang=js"
import style0 from "./PpvNegativesSection.vue?vue&type=style&index=0&id=458906d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458906d0",
  null
  
)

export default component.exports